
$(".language-btn").on("click", function() {

    const language = $(this).data('language'); // Read the data-language property
    const context = $(this).data('context'); // Read the data-language property
    console.log('Selected language:', language);

    
    $(`.code-block-${context}`).hide(); // Hide all code blocks
    $(`#code-${language}`).show();
    
    console.log($(this).siblings());
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
});

$('.d-block-submenu').on('click', function() {
    const yOffset = -130;
    const targetId = $(this).data('context'); // Get the target ID from the data attribute
    const element = document.getElementById(targetId);
    const y = element.getBoundingClientRect().top + window.scrollY + yOffset;

    window.scrollTo({top: y, behavior: 'smooth'});
})
$('.d-block-menu').on('click', function() {
    const yOffset = -130;
    const targetId = $(this).data('context'); // Get the target ID from the data attribute
    const element = document.getElementById(targetId);
    const y = element.getBoundingClientRect().top + window.scrollY + yOffset;

    window.scrollTo({top: y, behavior: 'smooth'});


})



